import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import gql from 'graphql-tag';
var BlogSeo = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  fragment seo on ComponentBlogSeo {\n    title\n    description\n  }\n"])));
export default BlogSeo;